'use strict';

// https://262.ecma-international.org/6.0/#sec-toobject

module.exports = require('es-object-atoms/ToObject');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/2024/ToObject.js
// module id = 692
// module chunks = 0